<template>
<div class="col-12 row">
  <div class="col-12 sensors">
    <sensors-list-component v-for="(sensor, index) in sensors" :sensor="sensor" :key="sensor.id_sensor" v-on:deleteRow="deleteRow(index)" />
  </div>
  <div class="col-12 empty-sensors-list-block" v-if="empty_sensors_list">
      <p>У вас нет ни одного датчика</p>
  </div>
  <div class="col-12 loader" v-if="load_sensors_list">
    <loader-component />
  </div>
  <div class="col-12 end-line-block" v-if="view_out_group_sensors"></div>
  <div class="col-12 out-group-sensors-text" v-if="view_out_group_sensors">
      <h3>Датчики не в группе</h3>
  </div>
  <og-sensors-list-component
    v-for="(sensor, index) in out_group_sensors" 
    :sensor="sensor" :key="sensor.id_sensor" 
    v-on:deleteRow="deleteOutGroupRow(index)"></og-sensors-list-component>
  <div class="col-12 center-button-block">
    <router-link :to="{ name: 'add-sensor', params: { id_group: id_group }}" class="aquazor-btn">
      Добавить датчик
    </router-link>
  </div>
</div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import axios from 'axios'
import {
  store
} from '@/store'
import loader from './elements/loader.vue'
import SensorRow from './elements/sensor_row.vue'
import OutGroupSensorRow from './elements/out_group_sensor_row.vue'

export default {
  name: 'Sensors',
  created() {
    sensors_list(this)
  },
  data() {
    return {
      sensors: [],
      out_group_sensors: [],
      load_sensors_list: false,
      load_new_sensors_list: false,
      group_name: '',
      sensor_list_status: true,
      page_name: 'sensors',
      id_group: this.$route.params.id_group,
      empty_sensors_list: false
    }
  },
  methods: {
    deleteRow: function (index_row) {
      this.sensors.splice(index_row, 1)
    },
    deleteOutGroupRow: function (index_row) {
      this.out_group_sensors.splice(index_row, 1)
    },
  },
  components: {
    'loader-component': loader,
    'sensors-list-component': SensorRow,
    'og-sensors-list-component': OutGroupSensorRow
  },
  computed: {
    view_out_group_sensors: function () {
        return this.out_group_sensors.length > 0
    }  
  },
  destroyed() {
    this.sensor_list_status = false
  },
}

function sensors_list(vue_obj) {
  if (vue_obj.sensor_list_status) {
    get_sensors_list(vue_obj)
    setTimeout(function () {
      sensors_list(vue_obj)
    }, config.UPDATE_PERIOD)
  }
}

function get_sensors_list(vue_obj) {
  if (!!localStorage.token) {
      var first_loader = false
    if (vue_obj.sensors.length == 0 && !vue_obj.empty_sensors_list) {
        vue_obj.load_sensors_list = true
        first_loader = true
    }
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_group', vue_obj.$route.params.id_group)
    axios({
        method: 'POST',
        url: config.API_HOST + '/sensors/list',
        data: post_data
      })
      .then(function (response) {
        vue_obj.load_sensors_list = false
        if (vue_obj.sensors.length == 0) {
          vue_obj.sensors = response.data.sensors
        } else {
          response.data.sensors.forEach(element => {
            let sensor_index = vue_obj.sensors.map(item => item.id_sensor).indexOf(element.id_sensor)
            if (sensor_index >= 0) {
              vue_obj.sensors[sensor_index].status = element.status
              vue_obj.sensors[sensor_index].name = element.name
              vue_obj.sensors[sensor_index].connection = element.connection
              vue_obj.sensors[sensor_index].serial_number = element.serial_number
              vue_obj.sensors[sensor_index].info_statuses = element.info_statuses
            } else {
              vue_obj.sensors.push(element)
            }
            vue_obj.sensors.forEach((view_element, index_element) => {
              let sensor_index = response.data.sensors.map(item => item.id_sensor).indexOf(view_element.id_sensor)
              if (sensor_index < 0) {
                vue_obj.deleteRow(index_element)
              }
            })
          });
        }
        if (vue_obj.sensors.length == 0) {
            vue_obj.empty_sensors_list = true
        }
        else {
            vue_obj.empty_sensors_list = false
        }
        vue_obj.load_sensors_list = first_loader
        get_out_group_sensors_list(vue_obj)
      })
      .catch(function (error) {

      })
  }
}

function get_out_group_sensors_list(vue_obj) {
  if (!!localStorage.token) {
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    post_data.set('id_group', vue_obj.$route.params.id_group)
    axios({
        method: 'POST',
        url: config.API_HOST + '/sensors/group_out_list',
        data: post_data
      })
      .then(function (response) {
        vue_obj.load_sensors_list = false
        if (vue_obj.out_group_sensors.length == 0) {
          vue_obj.out_group_sensors = response.data.sensors
        } else {
          response.data.sensors.forEach(element => {
            let sensor_index = vue_obj.out_group_sensors.map(item => item.id_sensor).indexOf(element.id_sensor)
            if (sensor_index >= 0) {
              vue_obj.out_group_sensors[sensor_index].name = element.name
              vue_obj.out_group_sensors[sensor_index].serial_number = element.serial_number
            } else {
              vue_obj.out_group_sensors.unshift(element)
            }
            vue_obj.out_group_sensors.forEach((view_element, index_element) => {
              let sensor_index = response.data.sensors.map(item => item.id_sensor).indexOf(view_element.id_sensor)
              if (sensor_index < 0) {
                vue_obj.deleteOutGroupRow(index_element)
              }
            })
          });
        }
      })
      .catch(function (error) {

      })
  }
}


</script>

<style scoped>
.out-group-sensors-text {
    text-align: center;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/sensors-list.vue